(function () {
  'use strict';
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  /* apparition au défilement */
  function reveal() {
    var els = $$('.bb-rv:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }
  /* compte à rebours Black Friday */
  function endOf(el) {
    var raw = (el.getAttribute('data-end') || '').trim().replace(' ', 'T');
    var t = raw ? new Date(raw).getTime() : NaN;
    if (isNaN(t) || t <= Date.now()) { var d = new Date(); d.setHours(24, 0, 0, 0); t = d.getTime(); }
    return t;
  }
  function cd() {
    $$('[data-bb-cd]').forEach(function (el) {
      var left = Math.max(0, endOf(el) - Date.now()), s = Math.floor(left / 1000);
      var v = { d: Math.floor(s / 86400), h: Math.floor(s / 3600) % 24, m: Math.floor(s / 60) % 60, s: s % 60 };
      $$('[data-u]', el).forEach(function (b) { b.textContent = pad(v[b.getAttribute('data-u')]); });
    });
  }
  /* musique */
  function music() {
    var box = document.querySelector('[data-bb-mu]');
    if (!box || box._ok) return;
    box._ok = true;
    var btn = box.querySelector('[data-bb-mu-t]'), st = box.querySelector('[data-bb-mu-s]');
    function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }
    function ui(on, txt) { box.classList.toggle('is-on', on); btn.setAttribute('aria-pressed', on ? 'true' : 'false'); if (st) st.textContent = txt || (on ? 'En lecture' : 'Appuyez pour écouter'); }
    if (box.getAttribute('data-kind') === 'embed') {
      var pan = box.querySelector('[data-bb-mu-p]'), fr = pan && pan.querySelector('iframe');
      btn.addEventListener('click', function () {
        if (!pan) return;
        var open = pan.hidden;
        if (open && fr && !fr.getAttribute('src')) {
          var src = fr.getAttribute('data-src');
          if (/youtube/.test(src)) src += (src.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1';
          if (/soundcloud/.test(src)) src = src.replace('auto_play=false', 'auto_play=true');
          fr.setAttribute('src', src);
        }
        pan.hidden = !open;
        ui(open, open ? 'Lecteur ouvert' : 'Appuyez pour écouter');
      });
      return;
    }
    var a = box.querySelector('[data-bb-audio]');
    if (!a) return;
    a.volume = Math.min(1, (parseInt(box.getAttribute('data-vol'), 10) || 60) / 100);
    function play() { a.preload = 'auto'; var p = a.play(); if (p && p.then) p.then(function () { ui(true); ss('bb-mu', '1'); }).catch(function () { ui(false); }); else ui(true); }
    function pause() { a.pause(); ui(false); ss('bb-mu', '0'); }
    var t0 = parseFloat(ss('bb-mu-t') || '0');
    if (t0) a.addEventListener('loadedmetadata', function () { try { a.currentTime = t0; } catch (e) {} }, { once: true });
    setInterval(function () { if (!a.paused) ss('bb-mu-t', String(a.currentTime)); }, 1000);
    window.addEventListener('pagehide', function () { if (!a.paused) ss('bb-mu-t', String(a.currentTime)); });
    btn.addEventListener('click', function () { if (a.paused) play(); else pause(); });
    var pref = ss('bb-mu');
    if (pref === '1' || (pref === null && box.getAttribute('data-auto') === 'true')) {
      play();
      var evs = ['pointerdown', 'keydown', 'touchstart'];
      var first = function (ev) { if (ev.target.closest && ev.target.closest('[data-bb-mu]')) return; if (a.paused && ss('bb-mu') !== '0') play(); evs.forEach(function (n) { document.removeEventListener(n, first, true); }); };
      evs.forEach(function (n) { document.addEventListener(n, first, true); });
    }
  }
  function boot() { reveal(); cd(); music(); }
  setInterval(cd, 1000);
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
